import {useEffect, useState} from 'react';
import {Button, Center, Stack, Text} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';
import {signInWithRedirect} from 'aws-amplify/auth';

// FNP-1708: the portal no longer has a sign-in page of its own. An anonymous
// visitor goes broker -> login app -> back here with a code, like every other app.
//
// ⚠️ LOOP GUARD. If the code exchange fails, the visitor comes back anonymous and
// would be sent straight out again, forever. A second redirect inside the window
// shows a button instead, so a broken round trip stops in front of a person.
const REDIRECT_MARK = 'portal-sign-in-redirect-at';
const LOOP_WINDOW_MS = 15000;

const readMark = (): number => {
    try {
        return Number(window.sessionStorage.getItem(REDIRECT_MARK) ?? 0);
    } catch {
        return 0;
    }
};

const writeMark = () => {
    try {
        window.sessionStorage.setItem(REDIRECT_MARK, String(Date.now()));
    } catch {
        // Storage blocked: the redirect still happens, only the guard is lost.
    }
};

const startSignIn = () => {
    writeMark();
    signInWithRedirect().catch((error) => console.error('Sign-in redirect failed', error));
};

export const RedirectToSignIn = () => {
    const [looping] = useState(() => Date.now() - readMark() < LOOP_WINDOW_MS);

    useEffect(() => {
        if (!looping) {
            startSignIn();
        }
    }, [looping]);

    if (!looping) {
        return (
            <Center>
                <PlatformLoader message='Redirecting to sign in...'/>
            </Center>
        );
    }

    return (
        <Center mih='50vh'>
            <Stack align='center'>
                <Text>Sign-in did not complete.</Text>
                <Button onClick={startSignIn}>Sign in</Button>
            </Stack>
        </Center>
    );
};
